import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@sharedModule/material/material.module';
import { InputSelectComponent } from './components/input-select/input-select.component';
import { InputTemplateComponent } from './components/input-template/input-template.component';
import { ValidationErrorComponent } from './components/validation-error/validation-error.component';
import { AuthInputComponent } from './components/auth-input/auth-input.component';
import { InputDatepickerComponent } from './components/input-datepicker/input-datepicker.component';
import { InputFileComponent } from './components/input-file/input-file.component';
import { InputImageCropComponent } from './components/input-image-crop/input-image-crop.component';

@NgModule({
  declarations: [
    AuthInputComponent,
    InputTemplateComponent,
    InputSelectComponent,
    ValidationErrorComponent,
    InputDatepickerComponent,
    InputFileComponent,
    InputImageCropComponent,
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule],
  exports: [
    AuthInputComponent,
    InputTemplateComponent,
    InputSelectComponent,
    ValidationErrorComponent,
    InputDatepickerComponent,
    InputFileComponent,
    InputImageCropComponent,
  ],
})
export class InputModule {}
